var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudCheck = function SvgCloudCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F3D8B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M6.321 23a5.464 5.464 0 0 1-.51-10.905 7.288 7.288 0 0 1 14.378 0A5.465 5.465 0 0 1 19.679 23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F3D8B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "m17.2 13-5.775 6L8.8 16.273"
  })));
};
export default SvgCloudCheck;